const routes = {
  dashboard: '/',
  ngamenbizz: '/ngamenbizz',
};

export default routes;
